export const ListTypes = {
  Bullet: 'bulletList',
  Ordered: 'orderedList',
} as const;

export type ListTypeName = (typeof ListTypes)[keyof typeof ListTypes];
